import { render, staticRenderFns } from "./DialogCall.vue?vue&type=template&id=41ed29dc&scoped=true&"
import script from "./DialogCall.vue?vue&type=script&lang=js&"
export * from "./DialogCall.vue?vue&type=script&lang=js&"
import style0 from "./DialogCall.vue?vue&type=style&index=0&id=41ed29dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ed29dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDialog,VRow})
